import React from 'react';
import {
  Container, Row,
} from 'reactstrap';
import SettingsDataPage from './components/SettingsDataPage';
import PageHeader from '../../../../shared/components/PageHeader';
import Panel from '../../../../shared/components/Panel';

export default function AccountSettingsManagement() {
  return (
    <Container>
      <Row>
        <PageHeader title="Account Settings Data" subhead="Configure global account settings groups and access permissions." />
      </Row>
      <Row>
        <Panel md={12} title="Notes" defaultOpen showNameButton showMinusButton={false} showRefreshButton={false}>
          <p>
            <br /><b>Admin Only Access</b> - <span>{JSON.stringify({ scope: 'admin' })}</span>
            <br /><b>Role Based Access</b> - <span>{JSON.stringify({ scope: 'user', roleList: ['superRole', 'adminAccountRole'] })}</span>
            <br /><b>Note</b> - Role based access is granted to all users having one or more of the roles specified.
          </p>
        </Panel>
      </Row>
      <Row>
        <SettingsDataPage />
      </Row>
    </Container>
  );
}

